import { Loading } from "app/components/Wrappers";
import React from "react";
import Tippy from "@tippyjs/react/headless";
import styles from "../styles.module.scss";
import { camelCase } from "lodash";
import { formatReportValue } from './helper';

const renderCellContent = (column, value) => {
  if (column.columnType === 'link' && value) {
    return (
      <a href={value} target="_blank" rel="noopener noreferrer">
        {column.linkLabel || value}
      </a>
    );
  }
  return value;
};

const TruncatedCell = ({ fullText, children }) => (
  <Tippy
    placement="top"
    delay={[150, 0]}
    render={(attrs) => (
      <div className={styles.cell_tooltip} tabIndex={-1} {...attrs}>
        {fullText}
      </div>
    )}
  >
    <span>{children}</span>
  </Tippy>
);

const ReportBody = ({
  data,
  columns,
  loading,
  reportId,
}) => {
  const loadingOverlay = (
    <tr className={styles.loading}>
      <td colSpan={100} className="">
        <Loading isLoading loadType="spinner" />
      </td>
    </tr>
  );

  return (
    <>
      {loading ? (
        loadingOverlay
      ) : (data ? (
        data.map((row) => (
          <tr
            key={row.id}
            className={styles.table_body_row}>
            {columns.map((column) => {
              const isEmail = column.fieldName.includes('email');
              const shouldTruncate = column.truncate || isEmail;
              const cellClass = shouldTruncate ? styles.column_truncate : styles.column;
              const rawValue = row[camelCase(column.fieldName)];
              const value = formatReportValue(reportId, camelCase(column.fieldName), row);
              const cellContent = renderCellContent(column, value);
              return (
                <td
                  key={column.fieldName}
                  className={cellClass}
                  style={column.multiline ? { whiteSpace: 'pre-line' } : undefined}>
                  {column.truncate && rawValue ? (
                    <TruncatedCell fullText={rawValue}>{cellContent}</TruncatedCell>
                  ) : isEmail ? (
                    <span title={rawValue}>{cellContent}</span>
                  ) : cellContent}
                </td>
              );
            })}
          </tr>
        ))
      ) : null)}
      <tr></tr>
    </>
  );
};

export default ReportBody;
